import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationEvent } from '../../models/events/notification-event.model';
import { NotificationEventService } from '../../services/event/notification-event.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-notification-event-list',
    templateUrl: './notification-event-list.component.html',
    styleUrls: ['./notification-event-list.component.css']
})
/** notification-event-list component*/
export class NotificationEventListComponent {
  public notificationEventList: NotificationEvent[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
    /** notification-event-list ctor */
  constructor(private readonly notificationEventService: NotificationEventService,
    private readonly utilitiesService: UtilitiesService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService, private router: Router) {
    this.rolePermissionService.GetRolePermissions("notificationevent").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.toastr.setRootViewContainerRef(vcr);
          this.GetNotificationEvents();
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  GetNotificationEvents() {
    this.notificationEventService.GetNotificationEvents().subscribe(
      data => {
        this.notificationEventList = data;
        this.filteredItems = data;
      }
    )
  }

  deleteNotificationEvent(id) {
    var ans = confirm("Are you sure to delete this notification event ");
    if (ans) {
      this.notificationEventService.DeleteNotificationEvent(id);
      this.toastr.success('Notificationt Event deleted successfully.', 'Success');
      setTimeout(() => {
        this.GetNotificationEvents();
      }, 2000);
    }
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.notificationEventList, searchText);

    } else {
      this.filteredItems = this.notificationEventList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/event-components/notification-event-list/notification-event-list.component.ts